import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router'

import { AppState } from "store";
import targetComponent from 'components/trainer/StudentStudyResult';
import studyResultActions from 'actions/studyResultActions';
import { isRecommendCurriculum }  from 'utils/store'

const mapDispatchToProps = (dispatch: Dispatch) => ({ dispatch })

const mapStateToProps = (appState: AppState, ownProps: RouteComponentProps) => {
  return {
    user: appState.session.user!,
    trainer: appState.trainer,
    studyResult: appState.studyResult,
    ...ownProps,
  }
}

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  { dispatch }: ReturnType<typeof mapDispatchToProps>) => {
  return {
    ...stateProps,
    isRecommendCurriculum,
    getStudent: (student_id: number) => {
      const student = stateProps.trainer.student
      if (student.student_id !== student_id) {
        return null
      }
      return student.record
    },
    getRecord: (student_id: number) => {
      const page = stateProps.studyResult.studyCurriculums
      if (page.student_id !== student_id) {
        return null
      }
      return page.record
    },
    fetchData: (student_id: number) => {
      dispatch(studyResultActions.fetchStudyCurriculums({ student_id, }))
    },
  }
}

export type mappedProps = ReturnType<typeof mergeProps>
export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(targetComponent))
